(() => {
 const form=document.getElementById('contact-form');if(!form)return;
 const type=document.getElementById('enquiry-type'),company=document.getElementById('contact-company');
 const params=new URLSearchParams(location.search);
 const allowed=[...type.options].map(x=>x.value);
 if(allowed.includes(params.get('type')))type.value=params.get('type');
 if(params.get('country'))document.getElementById('contact-country').value=params.get('country').slice(0,100);
 if(params.get('message'))document.getElementById('contact-message').value=params.get('message').slice(0,5000);
 function updateContext(){
  const dealer=type.value==='Dealer';company.required=dealer;
  document.getElementById('company-optional').textContent=dealer?'Required':'Optional';
  document.getElementById('enquiry-heading').textContent=dealer?'Become a Blue Marine Dealer.':'How can we help?';
  document.getElementById('enquiry-intro').textContent=dealer?'Tell us about your business, the region you serve and how you would like to represent Blue Marine.':'Tell us about your vessel, product enquiry or business. Our team will help you find the next step.';
  document.getElementById('contact-message').placeholder=dealer?'Your business, customer base, services and the region you cover…':'Tell us what you need help with…';
 }
 type.addEventListener('change',updateContext);updateContext();
})();
